//TODO: + write test for this util

import dayjs from 'dayjs'

export const formatDate = (timeStamp: number | string) => dayjs(`${new Date(timeStamp)}`).format('DD MMM YYYY')

// export const formatDate = (timeStamp: number) => {
//   const time = new Date(timeStamp)
//   const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][
//     time.getMonth() - 1
//   ]

//   const dayMonthYear = `${time.getDay()} ${month} ${time.getFullYear()}`

//   return dayMonthYear
// }
